import { createSlice } from "@reduxjs/toolkit"

export type helpCenterFolderType = {
  id: string
  index?: number
  title: string
  description: string
  is_private: boolean
  HelpCenterAttachments: Array<any>
}
type helpCenterStateType = {
  folders: { [key: number]: helpCenterFolderType }
  selectedFolderIndex: number | null
  documents: any
}

const initialState: helpCenterStateType = {
  folders: {},
  selectedFolderIndex: null,
  documents: {},
}

const helpCenterSlice = createSlice({
  name: "helpCenter",
  initialState,
  reducers: {
    setFolders: (state, action) => {
      state.folders = action.payload
    },
    setSelectedFolder: (state, action) => {
      state.selectedFolderIndex = action.payload
    },
    appendFolder: (state, action) => {
      const { data, response } = action.payload
      const newFolder = {
        ...response?.result,
        HelpCenterAttachments: response?.attachment_result,
      }
      const mergedData = { ...data, ...newFolder }
      let finalIndex = 0
      let newFolders = Object.values(state.folders).reduce(
        (newObj: any, folder: any, index: number) => {
          newObj[index] = folder
          finalIndex += 1
          return newObj
        },
        {},
      )
      newFolders[finalIndex] = mergedData
      state.folders = newFolders
    },
    updateFolder: (state, action) => {
      const { id, data } = action.payload
      state.folders[id].title = data?.title
      state.folders[id].description = data?.description
      state.folders[id].is_private = data?.is_private
    },
    deleteFolder: (state, action) => {
      const newList = { ...state.folders }
      delete newList[action.payload]
      state.folders = newList
    },
    // document handlers
    setDocumentsList: (state, action) => {
      state.documents = action.payload
    },

    appendDocuments: (state, action) => {
      const { key, data } = action.payload
      state.folders[key].HelpCenterAttachments =
        state.folders[key].HelpCenterAttachments.concat(data)
    },
    deleteDocument: (state, action) => {
      const { index, id } = action.payload
      const newDocList = state.folders[index].HelpCenterAttachments.filter(
        (file) => file?.key !== id,
      )
      state.folders[index].HelpCenterAttachments = newDocList
    },
  },
})

export default helpCenterSlice.reducer

export const {
  setFolders,
  appendFolder,
  deleteFolder,
  updateFolder,
  setSelectedFolder,
  // Document handlers
  setDocumentsList,
  appendDocuments,
  deleteDocument,
} = helpCenterSlice.actions
